import { LOGO_SIZES, getTokenLogoDisplay } from "@/utils/logo"
import Box from "@mui/material/Box"
import classNames from "classnames"
import { memo, useContext } from "react"
import TokenListContext from "../context"
import { type TokenListItemProps } from "./types"

const TokenListItem = ({ option, ...props }: TokenListItemProps) => {
  const { handleClose, handleTokenSelect, nickName, selectedToken, isShowDialog } = useContext(TokenListContext)

  return (
    <li
      {...props}
      className={classNames(
        props.className,
        "items-start px-2 py-[10px]",
        isShowDialog ? "bg-white rounded-xl py-3" : "bg-white py-[0.625rem] rounded-lg",
        selectedToken?.value === option.value ? "bg-secondary" : "cursor-pointer hover:bg-secondary",
      )}
      data-testid={`token-picker${nickName ? `-${nickName}` : ""}-${option.symbol}-${option.value}`}
      onClick={() => (selectedToken?.value === option.value ? handleClose() : handleTokenSelect(option))}
    >
      <Box className='flex items-center max-w-full gap-x-2'>
        <Box className='flex flex-shrink-0 items-center justify-center rounded-full overflow-hidden'>
          {getTokenLogoDisplay(option.symbol, { logo: option.icon }, LOGO_SIZES.MD)}
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
          }}
        >
          <span className='flex items-center gap-x-[5px]'>
            <span
              className='min-w-0 text-sm truncate font-semibold text-neutral-1000 token-symbol'
              title={option.symbol}
            >
              {option.symbol}
            </span>
          </span>
        </Box>
      </Box>
    </li>
  )
}

const memoTokenListItem = memo(TokenListItem)
memoTokenListItem.displayName = "TokenListItem"
export default memoTokenListItem
